import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-matconfirmdialog',
  templateUrl: './matconfirmdialog.component.html',
  styleUrls: ['./matconfirmdialog.component.scss']
})
export class MatconfirmdialogComponent implements OnInit {
  public confirmMessage: string;

  constructor(
    public dialogRef: MatDialogRef<MatconfirmdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.confirmMessage = this.data.confirmmessage;
  }

  ngOnInit() {}
}
